import React from "react";
import { gaEvent } from "../../utils/GoogleAnalytics/gatracking";

const KnowledgeBase = () => {

    const handleOpenKnowledgeBaselink = () => {
        window.open("https://indiamartkb.freshdesk.com/support/login", "", "width=800,height=700, left=100px, top=10");
        gaEvent("KnowledgeBase Button", "KnowledgeBase btn click", "click", "KnowledgeBase Button")
    }

    return (
        <div
            className="knowledge-base"
            onClick={handleOpenKnowledgeBaselink}
        >
            ?
        </div>
    );
};

export default KnowledgeBase;